import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import React from 'react';

export const useDateLocalizer = () => {
  const { locale } = useCurrentUrl();
  return React.useCallback((date: string) => new Date(date).toLocaleDateString(locale), [locale]);
};
